import {
  Frequency,
  PlanStatus,
  ScheduleType
} from "@foxone/api/src/models/hfox";
import { Colors } from "@/types";

const PeriodMeta = {
  Daily: {
    text: "hfox.period-daily",
    color: Colors.GREEN
  },
  Weekly: {
    text: "hfox.period-weekly",
    color: Colors.GREEN
  },
  Monthly: {
    text: "hfox.period-monthly",
    color: Colors.GREEN
  }
};

const PlanStatusMeta = {
  ACTIVE: {
    text: "common.active",
    color: Colors.GREEN
  },
  STOP: {
    text: "common.stopped",
    color: Colors.RED
  },
  MAINTAIN: {
    text: "common.maintain",
    color: Colors.GRAY
  }
};

const ScheduleTypeMeta = {
  [ScheduleType.AUTO]: {
    text: "hfox.enum.schedule.kind.auto",
    color: Colors.GREEN
  },
  [ScheduleType.MANUAL]: {
    text: "hfox.enum.schedule.kind.manual",
    color: Colors.WARNING
  }
};

export default {
  getPeriodMeta(frequency: Frequency | null) {
    if (!frequency) {
      return {
        text: "-",
        color: Colors.GRAY
      };
    }
    return PeriodMeta[frequency];
  },
  getStatusMeta(status: PlanStatus) {
    return PlanStatusMeta[status];
  },
  getScheduleTypeMeta(type: ScheduleType) {
    return ScheduleTypeMeta[type];
  }
};
